export default __webpack_public_path__ + "static/media/whip.cd92b58d.png";